module.exports = __webpack_public_path__ + "integration-default.png";